/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {
  EdgeWorkerService,
  createEdgeWorkerService,
  ConfigService as QpConfigService,
  createConfigService,
} from 'qp-facade';
import { EdgeWorker } from 'qp-ui-interface';
import { environment } from '../../../environments/environment';
import { AppConfig } from '../utils/constants/app-config.constant';
import { getChannelPartnerIDByLocation } from '../utils/evergentUtils';
import { LocalStorageService } from './storage/local-storage.service';
import { KEYS } from '../utils/constants/storage.constants';
import { getDeviceType } from '../utils/deviceUtils';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private appConfig!: AppConfig;
  private edgeWorkerService: EdgeWorkerService;
  private qpConfigService: QpConfigService;
  private inAppBanner: any;

  get applicationConfig(): AppConfig {
    return this.appConfig;
  }

  set applicationConfig(config: AppConfig) {
    this.appConfig = config;
  }

  get inAppBannerResult(): any {
    return this.inAppBanner;
  }

  set inAppBannerResult(banner: any) {
    this.inAppBanner = banner;
  }

  constructor(private localStorage: LocalStorageService) {
    // this.edgeWorkerService = createEdgeWorkerService(
    //   environment.configUrl,
    //   false
    // );
    this.qpConfigService = createConfigService(environment.configUrl);
  }

  /**
   * getConfig() Get all the offers, location and configuration
   *
   * @returns void
   */
  public async getConfig(): Promise<void> {
    return this.getAppData();
  }

  public async getAppData(): Promise<void> {
    // const edgeWorkerData: EdgeWorker =
    //   await this.edgeWorkerService.getEdgeWorkerData('samsungtizentv');
    const deviceType = getDeviceType();
    const response = await this.qpConfigService.getConfigData(deviceType);
    this.storeEdgeWorkerData(response);
    this.storeInAppBanner(response);
  }

  private storeEdgeWorkerData(edgeWorkerData: EdgeWorker): void {
    this.localStorage.setItem(
      KEYS.EDGE_WORKER_DATA,
      JSON.stringify(edgeWorkerData)
    );
    this.storeConfig(edgeWorkerData);
    // this.storeParsedRegion(edgeWorkerData);
  }

  private storeConfig(edgeWorkerData: EdgeWorker) {
    const appconfigNew: AppConfig = this.getParsedConfig(edgeWorkerData.config);
    this.localStorage.setItem(KEYS.CONFIG, JSON.stringify(appconfigNew));
    this.getActorImage(appconfigNew);
    this.appConfig = appconfigNew;
  }

  // private storeParsedRegion(edgeWorkerData: EdgeWorker): void {
  //   const city = this.localStorage.getItem(KEYS.CITY);
  //   const regionAPIResult = {
  //     city: city || edgeWorkerData.geo.country,
  //     country: edgeWorkerData.geo.country,
  //     countryCode: edgeWorkerData.geo.country.toUpperCase(),
  //     region: edgeWorkerData.geo.country,
  //     group: edgeWorkerData.geo.group,
  //     ipAddress: edgeWorkerData.geo.ip,
  //   };
  //   this.localStorage.setItem(KEYS.LOCATION, JSON.stringify(regionAPIResult));
  //   this.appConfig.channelPartnerID = getChannelPartnerIDByLocation(
  //     this.appConfig
  //   );
  // }

  private getParsedConfig(data: any): AppConfig {
    this.appConfig = this.getServiceConfig(data);
    this.getActorImage(data);
    this.applicationConfig = this.appConfig;
    return this.appConfig;
  }

  private getActorImage(data: any): void {
    this.localStorage.setItem(KEYS.TAMIL_ACTOR_IMAGE, data.tamilActorImage);
    this.localStorage.setItem(KEYS.TELUGU_ACTOR_IMAGE, data.teluguActorImage);
  }

  private removeQuerySpecialParams(params: any) {
    const fieldsToRemove = ['dst'];
    try {
      const object = JSON.parse(params);
      object.filter = object.filter.filter(
        (item) => !fieldsToRemove.includes(item.field)
      );
      return JSON.stringify(object);
    } catch (e) {
      return params;
    }
  }

  private getServiceConfig(payload: any): AppConfig {
    const appConfig: any = {};
    payload?.forEach((item: any) => {
      if (
        item.key === 'moreFromServiceFilterTemplate' ||
        item.key === 'recommendedGenreFilterTemplate'
      ) {
        appConfig[item.key] = this.removeQuerySpecialParams(
          CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(item.value))
        );
      } else {
        appConfig[item.key] = item.value;
      }
    });

    this.applicationConfig = appConfig;

    //set elapsedTime
    const endConfTime = new Date().getTime();

    if (!this.applicationConfig.enableUpgrade) {
      this.applicationConfig.enableUpgrade = 'false';
    }

    if (!this.applicationConfig.errorCodeTranslation) {
      this.applicationConfig.errorCodeTranslation =
        'https://static-assets-cdn.aha-stag.firstlight.ai/static/config/errorcodes.json';
    }

    if (!this.applicationConfig.linkDeviceURL) {
      this.applicationConfig.linkDeviceURL = 'https://staging.aha.video/';
    }

    return appConfig as AppConfig;
  }

  continueWatchingPageSize() {
    return parseInt(this.applicationConfig.continueWatchingPageSize) || 20;
  }

  favoritesPageSize() {
    return 100;
  }

  storeInAppBanner(edgeWorkerData: EdgeWorker) {
    const inAppBannerRaw = edgeWorkerData?.custom_aha?.banners;
    this.inAppBannerResult = inAppBannerRaw;
  }
}
